module.exports = __webpack_public_path__ + "img/jd.18cb4515.png";